var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldDisplayBanner)?_c('cmg-loyalty-sign-in-banner',{attrs:{"loyaltyBanner":_vm.homePageRewardsBanner,"data-analytics-section":"loyalty-banner-homepage"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }